/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-distribution-dashboard-panel-component.ts
 *
 * Created by randysorensen on 2019-02-19.
 */

function PartnerDistributionDashboardPanelController (
    this: JS5Object,
    _: JS5Object,
    MetricsDashboardService: JS5Object,
    UtilsService: JS5Object
) {

    this.getDateRange = () => {
        let dateRange = '';

        let fromDate = _.get(this, 'fromDate');
        let toDate = _.get(this, 'toDate');

        if (fromDate && toDate) {
            let fromMonth = _.invoke(fromDate, 'getMonth');
            fromMonth = UtilsService.constants.MONTHS[fromMonth];
            let fromYear = _.invoke(fromDate, 'getFullYear');

            let toMonth = _.invoke(toDate, 'getMonth');
            toMonth = UtilsService.constants.MONTHS[toMonth];
            let toYear = _.invoke(toDate, 'getFullYear');

            dateRange = `${fromMonth} ${fromYear} - ${toMonth} ${toYear}`;
        }

        return dateRange;
    };

    const metricsDataUpdated = (metricsData: JS5Object) => {
        this.fromDate = MetricsDashboardService.getCurrentCriteria().fromDate;
        this.toDate = MetricsDashboardService.getCurrentCriteria().toDate;
        this.partnerRatioMap = metricsData.partnerRatioMap;
    };

    this.$onInit = () => {
        this.fromDate = MetricsDashboardService.getCurrentCriteria().fromDate;
        this.toDate = MetricsDashboardService.getCurrentCriteria().toDate;
        this.partnerRatioMap = {};

        MetricsDashboardService.registerDataUpdateCallback(metricsDataUpdated);
    };

}

angular.module('prism-ui.metricsDashboard').component('partnerDistributionDashboardPanel', {
    controller: PartnerDistributionDashboardPanelController,
    templateUrl: 'dashboard/metrics/dashboard-panels/partner-distribution/partner-distribution-dashboard-panel-template.html',
    bindings: {
    }
});
